import { jsx as o, jsxs as r, Fragment as R } from "react/jsx-runtime";
import { clsx as U } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { Breakpoints as j } from "../../style/base/index.js";
import { normalizeVideoId as H } from "../../utils/normalize-video-id.js";
import { useBreakpointMatch as S } from "../../utils/use-breakpoint-match.js";
import { RocheUIButton as z } from "../button/roche-button.js";
import { RocheUIButtonAppearance as D, RocheUIButtonTarget as G } from "../button/roche-button-types.js";
import { RocheUIImage as P } from "../image/roche-image.js";
import { RocheUIImageFit as n, RocheUIImageRatio as Y } from "../image/roche-image.types.js";
import { RocheUIVideoPlayer as q } from "../video-player/roche-video-player.js";
import e from "./roche-hero-teaser.module.scss.js";
const ae = ({
  teaserTitle: s,
  teaserOverline: t,
  teaserDescription: c,
  teaserImage: l,
  teaserVideoId: x,
  teaserImageRatio: a,
  teaserImageAlt: h,
  imageFit: d,
  imageOnLeftSide: C = !1,
  primaryButtonUrl: b,
  primaryButtonText: m,
  primaryButtonVisuallyHiddenText: g,
  secondaryButton: M,
  onPrimaryButtonClick: A,
  leftIcon: B,
  rightIcon: L,
  unpublished: V,
  playLabel: E,
  pauseLabel: F,
  onVideoStateChange: p,
  target: I,
  awsServiceBaseUrl: T
}) => {
  const k = S(j.MEDIUM) ? !0 : C, f = H(x), _ = f !== "", i = !!l, N = i && d === n.CONTAIN, w = i && /* @__PURE__ */ o(
    P,
    {
      src: l ?? "",
      alt: h ?? "",
      ratio: a,
      imageFit: d,
      fillContainer: N
    }
  ), y = _ && /* @__PURE__ */ o(
    q,
    {
      awsServiceBaseUrl: T,
      service: "aws",
      videoId: f,
      previewAlt: h ?? "",
      playLabel: E ?? "",
      pauseLabel: F ?? "",
      videoLoop: !0,
      onVideoStateChange: (O) => {
        p && p(O);
      },
      videoFit: a === Y.ORIGINAL ? n.CONTAIN : n.COVER,
      videoRatio: a
    }
  ), v = (i || _) && /* @__PURE__ */ o(
    "div",
    {
      className: U(
        e["hero-teaser__media-container"],
        N && e["hero-teaser__media-container--contain"]
      ),
      children: i ? w : y
    }
  ), u = /* @__PURE__ */ r("div", { className: e["hero-teaser__info-container"], children: [
    /* @__PURE__ */ r("div", { className: e["hero-teaser__text-container"], children: [
      /* @__PURE__ */ r("div", { className: e["hero-teaser__title-container"], children: [
        t && t.length > 0 && /* @__PURE__ */ o("div", { className: e["hero-teaser__overline"], children: t }),
        s && /* @__PURE__ */ o("h2", { className: e["hero-teaser__title"], children: s })
      ] }),
      c && /* @__PURE__ */ o("p", { children: c })
    ] }),
    /* @__PURE__ */ r("div", { className: e["hero-teaser__button-container"], children: [
      m && /* @__PURE__ */ o(
        z,
        {
          target: I || G.SELF,
          hasMarginTop: !1,
          href: b,
          appearance: D.SECONDARY,
          text: m,
          visuallyHiddenText: g,
          onClick: A,
          leftIcon: B,
          rightIcon: L
        }
      ),
      M
    ] })
  ] });
  return /* @__PURE__ */ o("section", { className: U(e["hero-teaser"], V && e["hero-teaser--unpublished"]), children: k ? /* @__PURE__ */ r(R, { children: [
    v,
    " ",
    u
  ] }) : /* @__PURE__ */ r(R, { children: [
    u,
    " ",
    v
  ] }) });
};
export {
  ae as RocheUIHeroTeaser
};
